import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../redux/rootReducer";
import {Image} from "../../../API";
import React, {useRef, useState} from "react";
import {setImage} from "../disposalSlice";

const initialImageState: Image = {fileName: "", url: "", data: ""};

function useImage() {

    const dispatch = useDispatch();

    const {image} = useSelector((state: RootState) => state.disposal.currentDisposal);

    const [_image, _setImage] = useState<Image>(image ? image : initialImageState);
    const [error, setError] = useState<string | null>(null);

    const fileUploadRef = useRef<HTMLInputElement>(null);

    const openNativeImageModal = () => {
        setError(null);
        if (fileUploadRef !== null && fileUploadRef.current !== null) {
            fileUploadRef.current.click();
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {files} = event.target;
        if(files && files[0].size >  1024 * 1024 * 4) {
            setError("Das Foto darf nicht größer als 4 mb sein.");
        } else if (files) {
            let reader = new FileReader();
            reader.onload = () => {
                const splitResult: string[] = (reader.result as String).split(",");
                const data = splitResult[1];
                const fileType: string = splitResult[0].split("/")[1].split(";")[0];
                const fileName: string = "file1".concat(".").concat(fileType);
                const url = URL.createObjectURL(files[0]);
                const newImage: Image = {fileName, url, data};
                _setImage(newImage);
                dispatch(setImage(newImage));
            };
            reader.readAsDataURL(files[0]);
        }
    };

    const removeImage = () => {
        _setImage(initialImageState);
        dispatch(setImage(null));
    };

    const HiddenInputComponent = () => (
        <input
            type="file"
            id="avatar"
            name="avatar"
            onChange={handleFileChange}
            accept="image/png, image/jpeg"
            style={{display: "none"}}
            ref={fileUploadRef}
        />
    );

    return {
        image: _image,
        HiddenInputComponent,
        openNativeImageModal,
        removeImage,
        error
    };
}

export default useImage;
